/**
 * Utility function to convert null values to undefined for form compatibility.
 * Database entities use `null` for optional fields, but Zod schemas/forms expect `undefined`.
 */
export function nullToUndefined<T extends object>(obj: T): {
  [K in keyof T]: null extends T[K] ? Exclude<T[K], null> | undefined : T[K]
} {
  const result = {} as Record<string, unknown>
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key]
      result[key] = value === null ? undefined : value
    }
  }
  return result as {
    [K in keyof T]: null extends T[K] ? Exclude<T[K], null> | undefined : T[K]
  }
}

/**
 * Format a user's display name from firstName and lastName.
 * Handles null values gracefully.
 */
export function formatUserName(user: { firstName?: string | null; lastName?: string | null; email: string } | null | undefined): string {
  if (!user) return 'Unknown'
  const parts: string[] = []
  if (user.firstName) parts.push(user.firstName)
  if (user.lastName) parts.push(user.lastName)
  return parts.length > 0 ? parts.join(' ') : user.email
}
